// scroll({ behavior: 'smoot', ...
import { polyfill } from 'smoothscroll-polyfill';

let polyfilled = false;


export function smoothScrollToElement(el) {
    if (!polyfilled) {
        polyfill();
        polyfilled = true;
    }

    const docTop = document.body.scrollTop || document.documentElement.scrollTop;

    const elTopBound = el.getBoundingClientRect().top;
    const elTopMargin = Math.max(parseInt(window.getComputedStyle(el).marginTop), 0);

    const headerElement = document.querySelector('.tarot-desktop-header')
        || document.querySelector('.user-bar') || document.querySelector('tarot-top-bar');
    const offset = headerElement ? headerElement.offsetHeight : 0;

    const scrollTop = Math.max(docTop + elTopBound - elTopMargin - offset, 0);
    window.scroll({ top: scrollTop, behavior: 'smooth' });
}


// passive events
(function () {
    /*eslint-disable */
    let passiveSupported = false;

    window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
        get: function() {
            passiveSupported = true;
        },
    }));

    if (typeof onWheel !== 'undefined') {
        document.addEventListener('wheel', onWheel, passiveSupported ? { passive: true } : false);
    }

    if (typeof onMouseWheel !== 'undefined') {
        document.addEventListener('mousewheel', onMouseWheel, passiveSupported ? { passive: true } : false);
    }

    if (typeof onTouchStart !== 'undefined') {
        document.addEventListener('touchstart', onTouchStart, passiveSupported ? { passive: true } : false);
    }

    if (typeof onTouchMove !== 'undefined') {
        document.addEventListener('touchmove', onTouchMove, passiveSupported ? { passive: true } : false);
    }
}());



// WEBPACK FOOTER //
// ./app/scroll.js